import intl from "react-intl-universal";

const STATUS_STYLES = {
  active: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  pending: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  blocked: "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400",
  inactive: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400",
};

export const BaasStablesWalletStatusBadge = ({ status }) => (
  <span
    className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status] ?? STATUS_STYLES.inactive}`}
  >
    {intl.get(`baas.stablesWallet.walletStatus.${status}`)}
  </span>
);
